import { render, staticRenderFns } from "./ProductivityReport.vue?vue&type=template&id=0a7c1caf&scoped=true&"
import script from "./ProductivityReport.vue?vue&type=script&lang=js&"
export * from "./ProductivityReport.vue?vue&type=script&lang=js&"
import style0 from "./ProductivityReport.vue?vue&type=style&index=0&id=0a7c1caf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7c1caf",
  null
  
)

export default component.exports